import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductListItemDTO } from '../../../shared/product-list-item-dto';
import { WholesaleProductDTO } from '../../../shared/wholesale-product-dto';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http: HttpClient) { }

  getProductListItem(productId: number, options: { type_id?: number, overlay_id?: number, display?: boolean } = {}): Observable<ProductListItemDTO | WholesaleProductDTO> {
    var returnValue = this.http.get(`/api/product/listitem/${productId}?type_id=${options.type_id}${options.overlay_id ? `&overlay_id=${options.overlay_id}` : ''}${options.display ? `&display=${options.display}` : ''}`) as Observable<ProductListItemDTO | WholesaleProductDTO>;
    return returnValue;
  }

  getBundleListItem(bundleId: number): Observable<ProductListItemDTO> {
    var returnValue = this.http.get(`/api/product/listitem/${bundleId}/bundle`) as Observable<ProductListItemDTO>;
    return returnValue;
  }

  getProductDetail(url_alias: string, refresh?: boolean) {
    return this.http.get<any>(`/api/product/detail/${url_alias}${refresh ? '?refresh=true' : ''}`);
  }

  addNotificationEmail(email: string, productInstanceId: number): Observable<{ message: string }> {
    return this.http.post(`/api/product-instance-notification/add-email/${productInstanceId}`, { email }) as Observable<{ message: string }>;
  }

  captureClick(productId: number, pathname) {
    return this.http.post(`/api/product/capture`, { productId, pathname })
  }
}
